export default {
  name: 'SidebarLogo',
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  },
  data: function data() {
    return {
      title: 'ADN Dashboard',
      logo: '/favicon.ico'
    };
  }
};